const GameCampaignType = Object.freeze({
  0: 'BRACKET_PREDICTOR'
})

export { GameCampaignType }



// WEBPACK FOOTER //
// ./src/modules/gamification/enum/GameCampaignTypeEnum.js